import { render, staticRenderFns } from "./registration.vue?vue&type=template&id=1586b02a"
import script from "./registration.vue?vue&type=script&lang=js"
export * from "./registration.vue?vue&type=script&lang=js"
import style0 from "./registration.vue?vue&type=style&index=0&id=1586b02a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports